<template>
  <div>
    <div v-loading="pridobivanjeTelefonijaStoritev">
      <div style="padding-top: 35px">
        <p class="navadno-besedilo">
          Pogovor s prijatelji lahko traja v nedogled in nikoli ne zmanjka besed. Če uporabljate T-2
          telefonijo, lahko brezskrbno govorite po telefonu,
          <br/> saj vam omogoča ugodne klice doma in v
          tujino, vsi pogovori znotraj mobilnega in stacionarnega omrežja T-2 pa so brezplačni.
        </p>
      </div>
      <div v-if="Object.keys(asocSeznamVklopljenih).length > 0"
           class="zgornji-odmik-sprememba-telefonije forma-izbira-st-prikljuckov">
        <div v-for="storitev in seznamStoritev">
          <el-form label-width="210px" :label-position="formaOrientacija">
            <el-form-item :label=storitev.opis>
              <el-select v-model="izbranaKolicina[storitev.idStoritevVrstaIzbira]"
                         :disabled="typeof asocSeznamNarocenih[storitev.idStoritevVrstaIzbira] !== 'undefined'"
                         placeholder="Izberi"
                         :class="'velikost-izbirnika-kolicin '  +
                         (asocSeznamVklopljenih[storitev.idStoritevVrstaIzbira].kolicina !== izbranaKolicina[storitev.idStoritevVrstaIzbira] ? 'temna-pisava' :'')">
                <el-option v-for="data in naborPrikljuckovTelefonija" :key="data" :label="data" :value="data">
                </el-option>
              </el-select>
              <span v-if="typeof asocSeznamNarocenih[storitev.idStoritevVrstaIzbira] !== 'undefined'"
                    style="padding-left: 15px;">
                <b>
                  Naročilo v teku...
                </b>
              </span>
            </el-form-item>
          </el-form>
        </div>
        <div class="info-telefonija">
          <i>
            <img src="/static/img/UporabniskiKoticek/UporabneStrani/Icon-awesome-info-circle.png"
                 class="Icon-awesome-info-circle">
            <small class="open-sans-14pt levi-odmik-ikone">
              Za prenos številke od drugega operaterja nas prosim pokličite na 064 064 064.
            </small>
          </i>
        </div>
        <OrderButton
          style="padding-top: 50px"
          :disabled="allServicesSameTypeInOrder"
          :style="prikazTabele === '1' ? 'width: 250px;' : ''"
          :use-primary-class-only="true"
          :services="GetServices"
          class="postavitev-gumb-narocanje inline-button"
          :service-name="'spremembo telefonskih priključkov'"
          @orderConfirmed="OsveziPodatke()"
        >
          ODDAJTE SPREMEMBE
        </OrderButton>
      </div>
      <div class="odmik-cenik" style="clear: both;">
        <br/><br/>
        <a :href="cenikSpremembe" class="primarna-barva" target="_blank">
          Cenik za za spremembe
        </a>
      </div>
      <div v-if="Object.keys(asocSeznamVklopljenih).length > 0" class="postavitev-info">
        <div>
          <div class="info-okvir">
            <div class="postavitev-info-icone">
              <i class="fa fa-info-circle"></i>
            </div>
            <div class="postavitev-info-tekst">
              <p class="modra-barva-info">
                V izbirnikih je označeno skupno število naročenih in vklopljenih priključkov.
                Za spremembo nabora storitev, izberite število priključkov in oddajte naročilo.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both;" v-if="Object.keys(seznamNarocenihSpremembIzpis).length > 0" class="odmik-tabele">
        <p class="open-sans-20pt">
          Spremembe naročenih storitev
        </p>
        <el-table :data="seznamNarocenihSpremembIzpis">
          <el-table-column prop="opis" label="Storitev">
          </el-table-column>
          <el-table-column prop="trajanjeOd" label="Datum naročila">
          </el-table-column>
          <el-table-column prop="kolicinaPlus" label="Naročena količina">
          </el-table-column>
          <el-table-column prop="kolicinaMinus" label="Odjavljena količina">
          </el-table-column>
        </el-table>
        <OrderExistsInfo v-if="Object.keys(asocSeznamNarocenih).length > 0"/>
      </div>
      <div v-if="Object.keys(seznamNarocenihSpremembIzpis).length === 0" class="ni-narocenih-prikljcukov"/>
      <div style="clear: both"/>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {Button, Select, Option, Table, TableColumn, Form, FormItem, MessageBox, Collapse,
  CollapseItem} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
import {povezave} from '../../../../../assets/js/Povezave/povezave'

export default {
  name: 'Telefonija',
  mixins: [PridobivanjeVklopljenoNaroceno, SirinaOkna, StringConverter, PrikazVsebine],
  data () {
    return {
      clientAgent: null,
      cenikSpremembe: '',
      seznamVklopljenih: [],
      asocSeznamVklopljenih: {},
      seznamNarocenih: [],
      asocSeznamNarocenih: {},
      seznamStoritevCenik: [],
      seznamStoritev: [],
      seznamNarocenihSpremembIzpis: [],
      naborPrikljuckovTelefonija: [],
      seznamStoritevVklopljenih: [],
      izbranaKolicina: {},
      formaOrientacija: 'left',
      mejnaSirina: 500,
      pridobivanjeTelefonijaStoritev: false,
      expandRowKeys: [],
      prikazTabele: '1',
      mejnaSirinaTabela: 600,
      odstraniPrenosTelefonskeStevilke: 6007
    }
  },
  props: {
    izbranPrikljucek: ''
  },
  components: {
    OrderButton,
    PridobivanjeVklopljenoNaroceno,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [Form.name]: Form,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [FormItem.name]: FormItem,
    [TableColumn.name]: TableColumn,
    OrderExistsInfo
  },
  mounted () {
    this.cenikSpremembe = povezave.BASE_URL_CENIK_PODPORA
    this.clientAgent = new ClientAgent()
    if (this.izbranPrikljucek !== null) {
      this.OsveziPodatke()
      this.MozneIzbireTelefonija()
    }
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
  },
  computed: {
    allServicesSameTypeInOrder () {
      let out = true
      if (Array.isArray(this.seznamStoritev)) {
        this.seznamStoritev.forEach((item) => {
          if (typeof this.asocSeznamNarocenih[item.idStoritevVrstaIzbira] === 'undefined') {
            out = false
          }
        })
      }
      return out
    },
    GetServices () {
      let services = []
      for (let key in this.izbranaKolicina) {
        if (typeof this.izbranaKolicina[key] !== 'number' && !isFinite(this.izbranaKolicina[key])) {
          continue
        }
        let obstajaNarocenaKolicina = typeof this.asocSeznamNarocenih[key] !== 'undefined'
        if (
          (obstajaNarocenaKolicina && this.asocSeznamNarocenih[key].kolicina !== this.izbranaKolicina[key]) ||
          (!obstajaNarocenaKolicina && this.asocSeznamVklopljenih[key].kolicina !== this.izbranaKolicina[key])) {
          let quantityIsLower = false
          if (
            (obstajaNarocenaKolicina && this.asocSeznamNarocenih[key].kolicina > this.izbranaKolicina[key]) ||
            (!obstajaNarocenaKolicina && this.asocSeznamVklopljenih[key].kolicina > this.izbranaKolicina[key])
          ) {
            quantityIsLower = true
          }
          services.push({
            serviceId: Number.parseInt(key),
            quantity: this.izbranaKolicina[key],
            terminationPointId: Number.parseInt(this.izbranPrikljucek),
            quantityIsLower: quantityIsLower
          })
        }
      }
      return services
    }
  },
  watch: {
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetNaborTelefonijaStoritev()
      }
    }
  },
  methods: {
    OsveziPodatke () {
      this.GetNaborTelefonijaStoritev()
    },
    IzbiraVrsticeZaPrikazPodatkov (row) {
      const id = row.naziv
      const lastId = this.expandRowKeys[0]
      this.expandRowKeys = id === lastId ? [] : [id]
    },
    MetodaZaKlicNarocenihVkloplenih () {
      this.izbranaKolicina = {}
      let param = {}
      param.vmesnik = this
      param.prenesenIzbranId = this.izbranPrikljucek
      param.idVrsta = [3]
      param.idStatusNaroceno = 0
      param.idStatusVklopljeno = 1
      this.GetNaroceneStoritve(param)
    },
    GetNaborTelefonijaStoritev () {
      this.pridobivanjeTelefonijaStoritev = true
      if (this.izbranPrikljucek !== '') {
        let param = []
        param.push('idPrikljucek=' + this.izbranPrikljucek)
        this.clientAgent.postWsRequest(
          this,
          'prikljucek/storitve/naborTelefonijaStoritev',
          param,
          null,
          'SetSeznamStoritevTelefonija',
          'ErrSeznamStoritevTelefonija')
      }
    },
    SetSeznamStoritevTelefonija (podatki) {
      this.seznamStoritevCenik = []
      this.seznamStevilk = []
      this.seznamStoritev = []
      this.seznamStoritevCenik = podatki.data.cenik
      for (let i = 0; i < this.seznamStoritevCenik.length; i++) {
        if ('cena' in this.seznamStoritevCenik[i]) {
          Vue.set(this.seznamStoritevCenik[i], 'cenaSI', this.PikeVVejice(this.seznamStoritevCenik[i].cena))
          this.seznamStevilk = this.seznamStoritevCenik[i]
        }
      }
      this.$emit('cenikStoritevTelefonija', this.seznamStoritevCenik)
      for (let i = 0; i < podatki.data.storitve.length; i++) {
        if (podatki.data.storitve[i].idStoritevVrstaIzbira !== this.odstraniPrenosTelefonskeStevilke) {
          this.seznamStoritev.push(podatki.data.storitve[i])
        }
      }
      this.pridobivanjeTelefonijaStoritev = false
      this.MetodaZaKlicNarocenihVkloplenih()
    },
    ErrSeznamStoritevTelefonija  (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeTelefonijaStoritev = false
      this.MetodaZaKlicNarocenihVkloplenih()
    },
    NarocanjeStoritev (idStoritev, preklic = false) {
      if (preklic === false) {
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        let dovoljenKlicWs = false
        for (let key in this.izbranaKolicina) {
          if (typeof this.izbranaKolicina[key] !== 'number' && !isFinite(this.izbranaKolicina[key])) {
            continue
          }
          // izbrana kolicina je enaka vklopljeni => preklic narocene kolicine
          let obstajaNarocenaKolicina = typeof this.asocSeznamNarocenih[key] !== 'undefined'
          if (
            (obstajaNarocenaKolicina && this.asocSeznamNarocenih[key].kolicina !== this.izbranaKolicina[key]) ||
            (!obstajaNarocenaKolicina && this.asocSeznamVklopljenih[key].kolicina !== this.izbranaKolicina[key])) {
            param.push('seznamStoritev[' + key + ']=' + this.izbranaKolicina[key])
            dovoljenKlicWs = true
          }
        }
        if (dovoljenKlicWs) {
          this.clientAgent.postWsRequest(
            this,
            'prikljucek/storitve/narociStoritve?',
            param,
            param,
            'SetNarocanjeStoritevUspesno',
            'ErrseznamNarocenih')
        }
      } else { // preklic narocene storitve
        let vmesnikObj = this.asocSeznamVklopljenih[idStoritev]
        for (const i in this.seznamNarocenihSpremembIzpis) {
          if (vmesnikObj !== undefined && idStoritev === this.seznamNarocenihSpremembIzpis[i].idStoritev) {
            let kolicinaMinus = this.seznamNarocenihSpremembIzpis[i].kolicinaMinus
            let kolicinaPlus = this.seznamNarocenihSpremembIzpis[i].kolicinaPlus
            if (vmesnikObj.kolicina >= kolicinaMinus || vmesnikObj.kolicina <= kolicinaPlus) {
              let stTelPrikljuckov = vmesnikObj.kolicina
              if (kolicinaMinus !== 0) {
                stTelPrikljuckov = stTelPrikljuckov - kolicinaPlus
              } else if (kolicinaPlus !== 0) {
                stTelPrikljuckov = stTelPrikljuckov + kolicinaMinus
              }
              MessageBox.confirm('Ste prepričani, da želite odstraniti naročeno storitev?', {
                confirmButtonText: 'Da',
                cancelButtonText: 'Prekliči',
                confirmButtonClass: 'gumb-potrdi',
                cancelButtonClass: 'gumb-preklici',
                customClass: 'opozorilo-dialog'
              }).then(() => {
                let param = ['idPrikljucek=' + this.izbranPrikljucek]
                param.push('seznamStoritev[' + idStoritev + ']=' + stTelPrikljuckov)
                this.clientAgent.postWsRequest(
                  this,
                  'prikljucek/storitve/narociStoritve?',
                  param,
                  -1,
                  'SetNarocanjeStoritevUspesno',
                  'ErrseznamNarocenih')
              }).catch((err) => {
                err = null
              })
            }
          }
        }
      }
    },
    SetNarocanjeStoritevUspesno (podatki, storitevKolicina) {
      let paramObvestilo = {}
      if (storitevKolicina !== -1) {
        paramObvestilo.message = 'Naročilo uspešno oddano!'
        for (const i in this.seznamNarocenihSpremembIzpis) {
          if (this.seznamNarocenihSpremembIzpis[i].idStoritev.toString() === storitevKolicina.key) {
            paramObvestilo.message += this.seznamNarocenihSpremembIzpis[i].opis + ' (količina: ' +
              storitevKolicina.kolicina + ')'
          }
        }
        this.ShowSuccessMessage(paramObvestilo)
      } else { // preklic
        let paramObvestilo = {}
        paramObvestilo.message = 'Naročilo uspešno preklicano.'
        this.ShowSuccessMessage(paramObvestilo)
      }
      this.MetodaZaKlicNarocenihVkloplenih()
    },
    ErrseznamNarocenih (podatki) {
      this.ShowWarningMessage(podatki)
    },
    MozneIzbireTelefonija () {
      this.naborPrikljuckovTelefonija = []
      for (let i = 0; i <= 4; i++) {
        this.naborPrikljuckovTelefonija.push(i)
      }
    },
    // callback za GetNaroceneStoritve
    SetSeznamNarocenihStoritev (prenosniParametri, seznamNarocenih) {
      this.izbranaKolicina = {}
      this.seznamNarocenih = []
      this.asocSeznamNarocenih = {}
      this.seznamNarocenihSpremembIzpis = []
      this.seznamNarocenih = seznamNarocenih
      for (let i = 0; i < this.seznamNarocenih.length; i++) {
        let idStoritev = this.seznamNarocenih[i].idStoritev
        Vue.set(this.izbranaKolicina, idStoritev, this.seznamNarocenih[i].kolicina)
        Vue.set(this.asocSeznamNarocenih, idStoritev, JSON.parse(JSON.stringify(this.seznamNarocenih[i])))
      }
      this.GetVklopljeneStoritve(prenosniParametri)
    },
    // callback za GetVklopljeneStoritve
    SetSeznamVkloplenihStoritev (prenosniParametri, seznamVklopljenih) {
      this.seznamVklopljenih = []
      this.asocSeznamVklopljenih = {}
      this.seznamStoritevVklopljenih = []
      this.seznamVklopljenih = seznamVklopljenih
      if (typeof this.seznamVklopljenih !== 'undefined') {
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          this.seznamStoritevVklopljenih.push(this.seznamVklopljenih[i])
        }
        for (let i = 0; i < this.seznamStoritevVklopljenih.length; i++) {
          let idStoritev = this.seznamStoritevVklopljenih[i].idStoritev
          if (!(idStoritev in this.izbranaKolicina)) {
            Vue.set(this.izbranaKolicina, idStoritev, this.seznamStoritevVklopljenih[i].kolicina)
          }
          Vue.set(this.asocSeznamVklopljenih, idStoritev, this.seznamStoritevVklopljenih[i])
        }
      }
      for (let i = 0; i < this.seznamStoritev.length; i++) {
        let idStoritev = this.seznamStoritev[i].idStoritevVrstaIzbira
        if (!(idStoritev in this.izbranaKolicina)) {
          Vue.set(this.izbranaKolicina, this.seznamStoritev[i].idStoritevVrstaIzbira, 0)
        }
        if (!(idStoritev in this.asocSeznamVklopljenih)) {
          let obj = {}
          obj.kolicina = 0
          Vue.set(this.asocSeznamVklopljenih, idStoritev, obj)
        }
      }
      this.seznamNarocenihSpremembIzpis = []
      let stevec = 0
      for (let i in this.asocSeznamNarocenih) {
        let vklopljenaKolicina = 0
        if (typeof this.asocSeznamVklopljenih[i] !== 'undefined') {
          vklopljenaKolicina = this.asocSeznamVklopljenih[i].kolicina
        }
        let razlikaKolicin = this.asocSeznamNarocenih[i].kolicina - vklopljenaKolicina
        if (razlikaKolicin !== 0) {
          let obj = JSON.parse(JSON.stringify(this.asocSeznamNarocenih[i]))
          obj.kolicina = razlikaKolicin
          if (razlikaKolicin > 0) {
            obj.kolicinaPlus = razlikaKolicin
            obj.kolicinaMinus = 0
          } else if (razlikaKolicin < 0) {
            obj.kolicinaPlus = 0
            obj.kolicinaMinus = razlikaKolicin * -1
          }
          Vue.set(this.seznamNarocenihSpremembIzpis, stevec++, obj)
        }
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelefonija/NarociTelefonija.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelefonija/Telefonija.vue